export const MessageType = {
  Success: "Success",
  Info: "Info",
  Warn: "Warn",
  Error: "Error",
};
